<template>
    <div class="md-layout">
        <div class="md-layout-item md-small-size-100">
            <md-card>
                <md-card-header class="md-card-header-icon md-card-header-green">
                    <div class="card-icon">
                        <md-icon>tag</md-icon>
                    </div>
                    <h4 class="title">Add Skill</h4>
                </md-card-header>

                <form @submit.prevent="add">
                    <md-card-content>
                        <div class="text-right">
                            <md-button @click="goBack" class="md-primary md-dense">
                                Back to List
                            </md-button>
                        </div>

                        <div class="md-layout">
                            <label class="md-layout-item md-size-25 md-form-label">
                                Name
                            </label>
                            <div class="md-layout-item">
                                <md-field class="md-invalid">
                                    <md-input v-model="skill.name" />
                                    <validation-error :errors="apiValidationErrors.name" />
                                </md-field>
                            </div>
                        </div>
                        <div class="md-layout">
                            <label class="md-layout-item md-size-25 md-form-label">
                                Display Name
                            </label>
                            <div class="md-layout-item">
                                <md-field class="md-invalid">
                                    <md-input v-model="skill.display_name" />
                                    <validation-error :errors="apiValidationErrors.display_name" />
                                </md-field>
                            </div>
                        </div>
                        <div class="md-layout">
                            <label class="md-layout-item md-size-25 md-form-label">
                                Code
                            </label>
                            <div class="md-layout-item">
                                <md-field class="md-invalid">
                                    <md-input v-model="skill.code" />
                                    <validation-error :errors="apiValidationErrors.code" />
                                </md-field>
                            </div>
                        </div>
                        <div class="md-layout spacing">
                            <label class="md-layout-item md-size-25 md-form-label">
                                Category
                            </label>
                            <div class="md-layout-item">
                                <md-field>
                                    <label>Select Category</label>
                                    <md-select v-model="skill.skillCategory" name="zone_id">
                                        <md-option
                                                v-for="categoryData in available_category_dropdown"
                                                :key="categoryData.id"
                                                :value="categoryData.id"
                                        >
                                            {{ categoryData.name }}
                                        </md-option>
                                    </md-select>
                                </md-field>
                            </div>
                        </div>
                    </md-card-content>

                    <md-card-actions md-alignment="right">
                        <md-button type="submit" class="md-success">Add Skill</md-button>
                    </md-card-actions>
                </form>
            </md-card>
        </div>
    </div>
</template>
<script>
import { ValidationError } from '@/components';
import formMixin from '@/mixins/form-mixin';

export default {
    components: { ValidationError },

    mixins: [formMixin],

    data: () => ({


        skill: {
            type:'skills',
            name:null,
            display_name: null,
            code: null,
            skill_category_id:null,
            active: null,
        },
        available_category_dropdown: []
    }),
    created () {
        this. getCategoryDropDowns();
    },
    methods: {
        async add () {
            try {
                await this.$store.dispatch('skills/add',  this.skill);
                this.notifySuccess('Skills added successfully.');
                this.goBack();
            } catch (e) {
                if (e.response.data.errors[0]) {
                    await this.notifyError(e.response.data.errors[0].title);
                    this.setApiValidation(e.response.data.errors);
                } else {
                    await this.notifyError('Oops, something went wrong!');
                }
            }
        },
        getCategoryDropDowns () {
            this.$store.dispatch('skillCategories/list').then(() => {
                this.available_category_dropdown = this.$store.getters['skillCategories/dropdown'];
                if (this.available_category_dropdown && this.available_category_dropdown.length) {
                    console.log(this.available_category_dropdown);
                    this.skill.skill_category_id = this.available_category_dropdown[0].id;
                }
            });
        },

        goBack () {
            this.$router.push({ name: 'Skills List' });
        },

    },
};
</script>
